module.exports = __webpack_public_path__ + "media/images/es/how-works-icon-1-8d86e4cda2a9432f964f2570cb242697.png";